/* 
 * Custom radio buttons
 * 
 * /
(function() {
	const collectionSelector = '.radio-buttons-group';
	const selector = '.radio-button';
	const classNameSelected = 'selected';
	
	/*
	 * selectOptions 
	 * 
	 * Update UI (selected/not selected state) and 
	 * store value in linked input 
	 *
	 * @param button HTMLElement
	 * @return void
	 * /
	const selectOption = button => {	
		markAsSelected(button);
		setValue(button);
	};
	
	/*
	 * markAsSelected 
	 * 
	 * Update UI (selected/not selected state)
	 *
	 * @param button HTMLElement
	 * @return void
	 * /
	const markAsSelected = button => {
		unmarkAsSelected(button);
		button.classList.add(classNameSelected);
	};
	
	/*
	 * unmarkAsSelected 
	 * 
	 * Update UI — unset selected state on previous selected button)
	 *
	 * @param newSelectedButton HTMLElement
	 * @return void
	 * /
	const unmarkAsSelected = newSelectedButton => {
		const list = newSelectedButton.closest(collectionSelector);
		if(! list) 
			return;
		
		const ob = list.querySelector(selector +'.'+ classNameSelected +'[data-name='+ newSelectedButton.dataset.name +']');
		if( ob )
			ob.classList.remove(classNameSelected);
	};
	
	/*
	 * setValue 
	 * 
	 * Store value in linked input
	 *
	 * @param button HTMLElement
	 * @return void
	 * /
	const setValue = button => {
		const formControl = document.querySelector('input[name='+ button.dataset.name +']');
		if(! formControl ) 
			return;
		
		formControl.value = button.dataset.value;
	};
	
	/* 
	 * Attach behavior on all buttons on page
	 * 
	 * /
	document.querySelectorAll(selector).forEach(button => {
		button.addEventListener('click', event => {
			event.preventDefault();
			if( button.classList.contains(classNameSelected) )
				return;

			selectOption(event.currentTarget);
		});
	});
	
	/* 
	 * Select all buttons that are marked as selected on page load 
	 * 
	 * /
	document.querySelectorAll(selector +'.'+ classNameSelected).forEach(button => {
		selectOption(button);
	});
}());
*/




(function() {
	document.querySelectorAll('.form .input input, .form .input select, .form .input textarea').forEach(control => {
		
		if( control.getAttribute('disabled') ) {
			const holder = control.closest('.input');
			holder.classList.add('disabled');
			return;
		}
		
		control.addEventListener('focus', event => {
			const holder = event.currentTarget.closest('.input');
			holder.classList.add('focus');
		});
		
		control.addEventListener('blur', event => {
			const holder = event.currentTarget.closest('.input');
			holder.classList.remove('focus');
		});
	});
}());